<script lang="ts">
  interface $$Props
    extends svelte.JSX.DOMAttributes<HTMLButtonElement>,
      svelte.JSX.HTMLAttributes<HTMLButtonElement> {}
</script>

<style lang="postcss">
  button {
    position: relative;
    display: inline-flex;
    gap: var(--ubilabs-icon-button-gap);
    width: calc(var(--ubilabs-icon-button-icon-size) * 2);
    height: calc(var(--ubilabs-icon-button-icon-size) * 2);
    padding: calc(var(--ubilabs-icon-button-icon-size) / 2);
    background: none;
    outline: none;
    border: none;
    border-radius: var(--ubilabs-icon-button-icon-size);
    color: var(--ubilabs-icon-button-icon-color);
    font-size: var(--ubilabs-icon-button-icon-size);
    line-height: var(--ubilabs-icon-button-line-height);
  }

  button:not(:disabled):hover,
  button:not(:disabled):focus,
  button:not(:disabled):active,
  button:disabled {
    background-color: transparent;
  }

  button::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: var(--ubilabs-icon-button-icon-size);
    background-color: currentColor;
    opacity: 0;
  }

  button:not(:disabled):hover::before,
  button:not(:disabled):focus::before {
    opacity: 0.2;
  }

  button:not(:disabled):active::before,
  button:disabled::before {
    opacity: 0.1;
  }

  button:disabled {
    color: var(--ubilabs-icon-button-disabled-icon-color);
  }
</style>

<button {...$$restProps} class={$$props.class} on:click|preventDefault>
  <slot />
</button>
